module.exports = __webpack_public_path__ + "media/images/package-icon-9e7c63b269c37674089a3b12ec541930.svg";